import { Link } from 'gatsby';
import gsap from 'gsap';
import React, { useEffect, useRef } from 'react';
import Button from './Button';


const S1 = ()=>{
    return(
        <div className="flex flex-col max-w-full sm:max-w-sm">
            <div className="text-3xl sm:text-4xl font-bold">
                Creative Web Dev Agency
            </div>
            <p className="mt-4">Build your dream website for the best price in a most realistic way.</p>
            <Link to={`/get-started`} className="mt-10">
                <Button>Get Started</Button>
            </Link>
        </div>
    )
}
const S2 = ()=>{
    const bg= useRef()
    const fg= useRef()
    useEffect(()=>{
        gsap.timeline().to(bg.current,0.3,{
            scale:1,
            opacity:1,
            ease:'expo'
        }).to(fg.current,0.3,{
            scale:1,
            opacity:1,
            rotate:'6deg',
            ease:'expo'
        })
    },[])
    return(
        <div className="flex flex-col sm:my-0 mb-12 w-full items-center sm:w-72 h-52 sm:h-72 relative">
           <div ref={bg} className="w-11/12 max-w-xs sm:w-72 h-52 sm:h-72 bg-blue absolute opacity-0" style={{transform:'scale(0)'}}></div>
           <div ref={fg} className="w-11/12 max-w-xs sm:w-72 h-52 sm:h-72 bg-black  opacity-0" style={{transform:'rotate(0deg) scale(0)',background:`url(/static/hero_bg.jpg) no-repeat center`,backgroundSize:'cover'}}></div>
        </div>
    )
}
const Hero = () => {
    return (
        <div className="flex justify-between items-center sm:flex-row flex-col-reverse  mt-8 sm:mt-6 md:mt-10 lg:mt-12 xl:mt-20">
            <S1/>
            <S2/>
        </div>
    );
}

export default Hero;
